import IMask from 'imask'

function maskFieldValue(value, mask) {
  if (typeof mask === 'undefined') return value
  if (value === '' || value === undefined) return value

  const options = mask
  const maskOptions = typeof options === 'object' && options.mask ? options : { mask: options }

  const masked = IMask.createMask(maskOptions)

  return masked.resolve(value)
}

export default maskFieldValue

